import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { modoMobileCompleto } from '../../utils/modoMobileCompleto';

// "‹ Menu" de volta ao menu inicial mobile — só aparece no modo completo
// (suporterb nos sites de gestão); pros demais usuários não renderiza nada.
export default function BotaoMenuMobile({ className, style }) {
  const { usuario } = useAuth();
  if (!modoMobileCompleto(usuario)) return null;
  return (
    <Link to="/mobile" className={className}
      style={{ flexShrink: 0, textDecoration: 'none', fontWeight: 600, fontSize: 14, color: 'var(--primary)', ...style }}>
      ‹ Menu
    </Link>
  );
}
